<template>
    <div class="float-right">
        <span style="font-size: 16px" class="p-0">
            <a href="#" @click="decrement()">
                <i class="fas fa-chevron-square-left mr-2 mt-0 mb-0"></i>
            </a>
            {{ year }}
            <a href="#" @click="increment()">
                <i class="fas fa-chevron-square-right ml-2 mt-0 mb-0"></i>
            </a>
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'YearHandler',

    mixins: [DataUpdater],

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },

    methods: {
        increment() {
            this.$store.commit('browsing/INCREMENT_YEAR')
            this.$emit('update-data')
            this.updateData()
        },

        decrement() {
            this.$store.commit('browsing/DECREMENT_YEAR')
            this.$emit('update-data')
            this.updateData()
        },
    },
}
</script>

<style scoped>
a {
    color: #fff;
    text-decoration: none;
    background-color: transparent;
}

a:hover {
    color: #fff;
    text-decoration: none;
}
</style>
